import { Spacer } from '@chakra-ui/react';
import React from 'react';
import wrapColorTheme from '../lib/WrapColorTheme';
import { colors, styled } from '../Stitches';
import Scale from './Scale';

const EnvelopePrimitive = styled('div', {
  padding: '$5',

  borderWidth: '$1',
  borderRadius: '$3',

  cursor: 'pointer',

  transitionProperty: 'color',
  transitionDuration: '150ms',
  transitionTimingFunction: 'ease-in',

  variants: {
    theme: {
      dark: {
        color: 'white',
        background: colors.dark.whiteAlpha50,
        borderColor: colors.dark.whiteAlpha300,
        boxShadow: `2px 3px 0 ${colors.ldPurple}`,
      },
      light: {
        color: 'black',
        borderColor: colors.dark.darkAlpha700,
        boxShadow: `2px 3px 0px ${colors.gray900}`,
      },
    },
  },
});

const ThemedEnvelope = wrapColorTheme(EnvelopePrimitive);

const EnvelopeTitle = styled('p', {
  fontFamily: '$heading',
  fontSize: '$5',
  fontWeight: '500',
  wordWrap: 'break-word',
});

const EnvelopeParticulars = styled('p', {
  fontFamily: '$mono',
  fontSize: '$1',
});

const EnvelopeInnerFlex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

type EnvelopeProps = {
  onClick: () => void;
  title: string;
  subLine: string;
  bottomLine: string;
  tall?: boolean;
};

export const Envelope = ({ onClick, title, subLine, bottomLine, tall }: EnvelopeProps) => (
  <Scale onClick={onClick}>
    <ThemedEnvelope>
      <EnvelopeInnerFlex>
        <div>
          <EnvelopeTitle>{title}</EnvelopeTitle>
          <EnvelopeParticulars>{subLine}</EnvelopeParticulars>
          <Spacer h={tall ? 20 : 8} />
        </div>
        <EnvelopeParticulars>{bottomLine}</EnvelopeParticulars>
      </EnvelopeInnerFlex>
    </ThemedEnvelope>
  </Scale>
);
